/**
 * ファイルダウンロード用のカスタムフック
 */
export const useFileDownload = () => {
  /**
   * ファイルのダウンロードURLを生成する
   * @param url ファイルのURL
   * @param fileName ファイル名
   * @returns ダウンロード用のURL
   */
  const getDownloadUrl = (url: string, fileName: string): string => {
    const baseUrl = process.env.REACT_APP_KYOUSOU_API_BASE_URL
    const encodedUrl = encodeURIComponent(url)
    const encodedFileName = encodeURIComponent(fileName)
    return `${baseUrl}/download/file?url=${encodedUrl}&fileName=${encodedFileName}`
  }

  return {
    getDownloadUrl,
  }
}
